'use strict';

module.exports = {
    removePagination: function () {
        var holder = $('.holder, .pagination');
        var arrows = $('.jp-previous, .jp-next');
        var hidden = $('.jp-hidden');
        var current = $('.jp-current');

        if (holder) {
            holder.jPages('destroy');
            holder.hide();
        }
        if (arrows) {
            arrows.removeClass('jp-disabled');
        }
        if (hidden) {
            hidden.removeClass('jp-hidden');
        }
        if (current) {
            current.removeClass('jp-current');
            current.removeClass('btn-primary');
        }
    },

    addPagination: function (perPage) {
        var holder = $('div.holder');
        if (holder) {
            holder.jPages({
                containerID: 'storeContainer',
                previous: '',
                next: '',
                perPage: perPage,
                startPage: 1,
                startRange: 0,
                midRange: 4,
                endRange: 0
            });

            var pagination = $('.pagination');
            pagination.find('a').addClass('btn');
            pagination.find('span').addClass('btn');

            var current = $('.jp-current');
            current.addClass('btn-primary');

            holder.show();

            var previous = $('.jp-previous');
            var next = $('.jp-next');
            if (previous) {
                previous.attr('aria-label', 'previous');
            }
            if (next) {
                next.attr('aria-label', 'next');
            }

            $('body').on('click', '.pagination a, .pagination span', function () {
                $('.pagination').find('.btn').removeClass('btn-primary');
                $('.pagination').find('.jp-current').addClass('btn-primary');
            });
        }
    }
};
